export default __webpack_public_path__ + "static/media/Word-personaje-04.cb869002.png";